

import { useEffect, useRef, useState } from "react";
import { ContentView } from "../../components/content-view/ContentView";
import ContextualAppBar from "../../components/contextual-app-bar/ContextualAppBar";
import { ViewOptionStateEnum } from "../../components/contextual-app-bar/ViewOptionStateEnum";
import { useRouteContext } from "../../hooks/use-route-context/UseRouteContext";
import { useQueryNotifications } from "../../queries/UseQueryNotifications";
import { IOrganization } from "../../services/organization-data-service/Models";
import { useUserContext } from "../../contexts/user-context/UserContext";
import { useGroup } from "../../queries/groups/UseGroup";
import { AlarmScheduleListActionEnum, actionItems } from "./AlarmScheduleAdminActions";
import { ActionMenuItem, BaseActions } from "../../components/action-menu/ActionMenuItem";
import AlarmScheduleList, { AlarmScheduleListType } from "./alarm-schedule-list/AlarmScheduleList";
import { useOrganizations } from "../../queries/organizations/UseOrganizations";

export default function AlarmScheduleAdministrationView() {
    const [userState] = useUserContext();
    const routeContext = useRouteContext();
    const [organizationID, setOrganizationID] = useState<number>();
    const [viewOptionState, setViewOptionState] = useState(ViewOptionStateEnum.Default);

    
    const alarmScheduleListRef = useRef<AlarmScheduleListType>(undefined);

    const {data: group } = useQueryNotifications(useGroup)({
        customerID: userState.customer?.id as number,
        groupID: routeContext.groupID as number
    });

    const { data: organizations } = useQueryNotifications(useOrganizations)({});
    const organization = organizations?.find(o => o.id === organizationID);



    function onExecuteAction(menuItem: ActionMenuItem) {

         const item = menuItem.action as AlarmScheduleListActionEnum | BaseActions;

        switch (item) {
            case AlarmScheduleListActionEnum.Add:
                alarmScheduleListRef?.current?.executeAction(item);
                break;
        }
    }

    function onOrganizationChanged(item: IOrganization) {
        setOrganizationID(item.id);
    }

    useEffect(() => {
        if (group && organizationID === undefined) {
            setOrganizationID(group.organizationID as number);
        }
    }, [
        group,
        organizationID,
        setOrganizationID
    ]);
    
    return (
        <ContentView>
            <ContextualAppBar 
                hideBreadcrumb={true}
                actions={actionItems} 
                viewOptionState={viewOptionState}
                onExecuteAction={onExecuteAction} 
                showOrganizationPicker={true}
                onOrganizationSelected={onOrganizationChanged}
                organizationID={organizationID}
            />
           {
                organizationID && 
                <AlarmScheduleList
                    ref={alarmScheduleListRef}
                    groupID={organization?.peerGroupID as number}
                    organizationID={organizationID}
                    setViewOptionState={(viewOption) => setViewOptionState(viewOption)}
                />
            }

        </ContentView>
    );
  }
